/**
 * @generated SignedSource<<23f73d2b3a50f124626abe07580f08bb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CancelStage = "CancelImpossible" | "CancelPossibleAfterDeclare" | "CancelPossibleBeforeDeclare" | "CancelPossibleImmediately" | "Canceling";
export type RefundStage = "Declare" | "PaymentComplete" | "RefundCompleteA" | "RefundCompleteB" | "RefundDetermine" | "RefundPreDetermine" | "Review" | "Unknown";
export type RefundStatus = "ApplyComplete" | "ApplyImpossible" | "ApplyPossible" | "Complete" | "Impossible" | "None" | "Possible" | "RefundFinish" | "RefundImpossible" | "Retry";
export type mySectionUserQuery$variables = Record<PropertyKey, never>;
export type mySectionUserQuery$data = {
  readonly bznavRefund: {
    readonly user: {
      readonly corps: ReadonlyArray<{
        readonly cancelStage: CancelStage | null | undefined;
        readonly refundStage: RefundStage | null | undefined;
        readonly refundStatus: RefundStatus;
      }> | null | undefined;
      readonly email: string | null | undefined;
      readonly indis: ReadonlyArray<{
        readonly cancelStage: CancelStage | null | undefined;
        readonly refundStage: RefundStage | null | undefined;
        readonly refundStatus: RefundStatus;
      }> | null | undefined;
      readonly name: string | null | undefined;
      readonly previousIndis: ReadonlyArray<{
        readonly cancelStage: CancelStage | null | undefined;
        readonly refundStage: RefundStage | null | undefined;
        readonly refundStatus: RefundStatus;
      }> | null | undefined;
    };
  };
};
export type mySectionUserQuery = {
  response: mySectionUserQuery$data;
  variables: mySectionUserQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "refundStatus",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "refundStage",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cancelStage",
  "storageKey": null
},
v5 = [
  (v2/*: any*/),
  (v3/*: any*/),
  (v4/*: any*/)
],
v6 = [
  (v2/*: any*/),
  (v3/*: any*/),
  (v4/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "mySectionUserQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "BznavRefundOutput",
        "kind": "LinkedField",
        "name": "bznavRefund",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RefundUserType",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RefundHistoryType",
                "kind": "LinkedField",
                "name": "indis",
                "plural": true,
                "selections": (v5/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RefundHistoryType",
                "kind": "LinkedField",
                "name": "previousIndis",
                "plural": true,
                "selections": (v5/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RefundHistoryType",
                "kind": "LinkedField",
                "name": "corps",
                "plural": true,
                "selections": (v5/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "mySectionUserQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "BznavRefundOutput",
        "kind": "LinkedField",
        "name": "bznavRefund",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RefundUserType",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RefundHistoryType",
                "kind": "LinkedField",
                "name": "indis",
                "plural": true,
                "selections": (v6/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RefundHistoryType",
                "kind": "LinkedField",
                "name": "previousIndis",
                "plural": true,
                "selections": (v6/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RefundHistoryType",
                "kind": "LinkedField",
                "name": "corps",
                "plural": true,
                "selections": (v6/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fd9c26ee03ec667a7c65b69a430da3bd",
    "id": null,
    "metadata": {},
    "name": "mySectionUserQuery",
    "operationKind": "query",
    "text": "query mySectionUserQuery {\n  bznavRefund {\n    user {\n      name\n      email\n      indis {\n        refundStatus\n        refundStage\n        cancelStage\n        id\n      }\n      previousIndis {\n        refundStatus\n        refundStage\n        cancelStage\n        id\n      }\n      corps {\n        refundStatus\n        refundStage\n        cancelStage\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "dc5c44c59f4763c0f67d989cbcfb5e0e";

export default node;
